// Real per-item inventory icons, extracted+converted from the game's own
// BSA-packed .dds textures (see the extraction pipeline that populated
// src/assets/itemIcons/ - manifest.json maps the exact same itemFormId
// string craftRecipes.json/the craftMenuOpen packet already carries -
// bare hex for Skyrim.esm-native items, "<hex>:Plugin.esm" for
// cross-plugin ones - to the PNG filename it was saved as).
//
// Not every recipe's output has a resolvable icon (some vanilla items have
// no real ICON/MICO subrecord, some BSA searches came up empty) - itemIcon()
// returns undefined for those, and the caller falls back to the existing
// generic category glyph (icons.tsx) rather than showing a broken image.
import manifestJson from '../../assets/itemIcons/manifest.json';

const manifest = manifestJson as Record<string, string>;

// require.context: webpack-only API (this project builds with plain
// webpack 5, not esbuild/vite - see webpack.config.ts) that eagerly
// resolves every matching file in a directory at build time, so a new
// icon dropped into src/assets/itemIcons/ is picked up without editing
// this file - same reasoning as horseImages.ts's per-file imports, just
// generalized since there are ~200 of these instead of 5.
const iconContext = (require as unknown as {
  context(dir: string, useSubdirectories: boolean, regExp: RegExp): { keys(): string[]; (key: string): string };
}).context('../../assets/itemIcons', false, /\.png$/);

const iconUrlsByFilename: Record<string, string> = {};
for (const key of iconContext.keys()) {
  const filename = key.replace(/^\.\//, '');
  iconUrlsByFilename[filename] = iconContext(key);
}

export function itemIconUrl(itemFormId: string): string | undefined {
  const filename = manifest[itemFormId];
  return filename ? iconUrlsByFilename[filename] : undefined;
}
